import { render, staticRenderFns } from "./PartStockDetails.vue?vue&type=template&id=5bfd482c"
import script from "./PartStockDetails.vue?vue&type=script&lang=js"
export * from "./PartStockDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports